import { gql } from "@apollo/client";

export const GET_DEFLEET_CENTRES = gql`
  query getDefleetCentres {
    getDefleetCentres {
         	id
			isActive
			partnerId
			partnerName
			partnerType
			address {
				street
				city
				fullAddress
				state
				country
				zipcode
			}
			email
			phoneNumber {
				phone 
				country
			}
			companyRegistrationNo
			partnerContact {
				firstName
    		lastName
				phoneNumber {
					phone 
					country
				}
    		email
			}
			# documents
			# tenantId
			# organisationId
			# branchId
			createdAt
			createdBy
			updatedAt
			updatedBy
    }
  }
`;